import { Scroll, ScrollControls, useScroll} from '@react-three/drei'
import { useState, useEffect, useRef, useContext} from 'react'
import { useFrame, useThree } from '@react-three/fiber';
import { Physics } from '@react-three/rapier'
import { MathUtils } from 'three';
import { Perf } from 'r3f-perf'
import * as THREE from 'three'
import Environment from './Environment'
import Me from './Me'
import Level2 from './Level2'
import { Navigation } from './Navigation'
import { useModal } from './ModalContext'


export default function Experience() {
  const [buttonsMargin, setbuttonsMargin] = useState(40) 
  const [cameraShake, setCameraShake] = useState(0)
  const { camera } = useThree(); // Accessing the camera
  const [darkMode, setDM] = useState(false);
  const { isOpen } = useModal();
  
 
  useEffect(() => {
    // Adjusting the FOV based on screen size
    const listener = new THREE.AudioListener();
    camera.add( listener );
    const handleResize = () => {
      if (window.innerWidth < 780) {
        camera.fov = 50; // FOV for mobile devices
        setbuttonsMargin(20) 
      } else {
        camera.fov = 35; // FOV for desktop
        setbuttonsMargin(40) 
      }
      camera.updateProjectionMatrix(); // Update the camera with new settings
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Calling once initially to set the correct FOV
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [camera]);

  useEffect(() => {
    if (cameraShake<0.1)
    {
      camera.position.x = 0;
      camera.position.z = 65;
    }
  }, [cameraShake]);

  useFrame((state, delta)=>{
    if (cameraShake>0.1)
    {
      camera.position.x += Math.sin(Math.PI * 20 * state.clock.elapsedTime)/20
      camera.position.z += Math.sin(Math.PI * 20 * state.clock.elapsedTime)/20
      setCameraShake(MathUtils.lerp(cameraShake, 0, 20 * delta))
    }
  }) 


  return (
    <>

      {/* <Perf position="top-left" /> */}
      {/* <OrbitControls makeDefault/> */}
      <ScrollControls pages={6} damping={0.08} distance={1.8} enabled={!isOpen}>
        <ScrollLock />

        <Me darkMode={darkMode}/>
        <Scroll html>
          <Navigation />
        </Scroll>
        <Scroll>

          <Physics timeStep={1 / 60}>
            <Level2 buttonsMargin = {buttonsMargin} setCameraShake = {setCameraShake}/>
            <Environment setDM = {setDM}/>
          </Physics>   
        </Scroll>   
      </ScrollControls>
      
    </>
  );
}

function ScrollLock() {
  const { isOpen } = useModal();
  const scroll = useScroll();
  const savedTop = useRef(0);
  const savedOffset = useRef(0);
  useEffect(() => {
    if (!scroll || !scroll.el) return;
    if (isOpen) {
      savedTop.current = scroll.el.scrollTop;
      savedOffset.current = scroll.offset; // normalized 0..1
      // don't change overflow of the scroll container; let body lock handle scrolling
    } else {
      const maxTop = scroll.el.scrollHeight - scroll.el.clientHeight;
      const targetTop = Math.max(0, Math.min(maxTop, savedOffset.current * maxTop));
      scroll.el.scrollTo({ top: targetTop, behavior: 'auto' });
    }
  }, [isOpen, scroll]);
  return null;
}
